<template>
    <div class="checkout__container">
        <v-card class="mx-auto">
            <v-card-text>
                <Checkout/>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import Checkout from '@/components/checkout-info'

export default {
    mixins: [languageMixins],
    components: { Checkout },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/checkout/_index.scss';
</style>
